import ExamStoreAPI from '@/apis/business/teacher/exam-store-api.js'
import Enumeration from '@/common/enumeration'
import { handleMappingAnswer } from '@/views/pages/teacher/storage/create/common/common.js'
import { sessionStorageKeys } from '@/common/storage-keys.ts'
import { sessionStorage } from '@/utils/storage'

export default {
  namespaced: true,

  state: {
    exams: [],
    exam: {},
    quantityExam: {
      Teacher: 0,
      School: 0,
      Share: 0
    },
    questions: [],
    examStore: null,
    selectedQuestion: 1,
    questionsDemo: [],
    examShares: [],
    examForShare: [],
    totalExercise: null,
    currentItem: {
      GradeID: null,
      SubjectID: null,
      queryText: null
    },
    currentPage: Enumeration.Pagination.CurrentPage,
    dataShares: [],
    dataChoosePage: [],
    qtyQuestionHint: 0

  },

  getters: {
    /**
     * @author PVThang
     * @param {*} state
     * @returns exam
     */
    getExam (state) {
      return state.exam || {}
    },

    /**
     * @author NTQuy
     * @description Danh sách câu hỏi đã hoàn thành
     * @param {*} state
     * @returns
     */
    questionDones (state) {
      const indexs = []

      state.questions?.map((question, index) => {
        let check = false

        if (question.Type === Enumeration.QuestionType.Fill || question.Type === Enumeration.QuestionType.Essay) {
          if (question.Answers?.length) {
            check = question.Answers?.some(answer => {
              return answer.Content || answer.AnswerAttachment
            })
          }
        } else {
          check = question.Answers?.some(answer => {
            return answer.Correct
          })
        }
        if (check) {
          indexs.push(index)
        }
      })

      return indexs
    }
  },

  mutations: {
    /**
     * @author PVThang
     * @description set giá trị cho exam
     */
    setExam (state, newExam) {
      state.exam = newExam
    },

    clearQuestions (state) {
      state.questions = []
    },

    setQtyQuestionHint (state, qtyQuestionHint) {
      state.qtyQuestionHint = qtyQuestionHint
    },

    /**
     * @author PVThang
     * @param {*} state
     * @param {*} newExams
     * @description set giá trị cho exams
     */
    setExams (state, newExams) {
      state.exams = newExams || []
    },

    /**
     * @author PVThang
     * @param {*} state
     * @param {*} quantityExam
     * @description set số lượng đề kiểm tra
     */
    mergeQuantityExam (state, quantityExam) {
      state.quantityExam = { ...state.quantityExam, ...quantityExam }
    },

    /**
     * @description Clone questions từ store document sang phục vụ cho việc switch giữa 2 dạng
     * làm thử theo danh sách và theo từng câu
     * @author NTQuy
     * @param {*} state
     * @param {*} questions
     */
    setQuestions (state, questions) {
      state.questions = questions
    },

    /**
     * @description Lưu bài làm thử của giáo viên
     * @author NTQuy
     * @param {*} state
     * @param {*} questionsDemo
     */
    setQuestionsDemo (state, questionsDemo) {
      state.questionsDemo = questionsDemo
    },

    /**
     * @description
     * @author lhlong
     * @param {*} state
     * @param {*} examStore
     */
    setExamStore (state, examStore) {
      state.examStore = examStore
    },

    /**
     * @description set giá trị cho câu hỏi đang được select
     * @author NTQuy
     * @param {*} state
     * @param {*} index
     */
    setSelectedQuestion (state, index) {
      const totalQuestion = state.examStore?.Questions?.length
      if (index && index <= totalQuestion) {
        state.selectedQuestion = index
      }

      // cập nhật câu hỏi được chọn
    },

    setFromRouter (state, fromRouter) {
      if (!fromRouter?.includes('teacher-exam-demo')) {
        state.fromRouter.defaultFrom = fromRouter
      }
    },

    setExamShare (state, ListId) {
      state.exams = state.exams.map((item) => {
        ListId.map((id) => {
          if (item.Id === id) {
            item.IsShared = true
          }
        })
        return item
      })
    },

    /**
     * @description Thêm bài tập vào danh sách được chia sẻ
     * @author NVDuc
     * @param {*} state
     * @param {*} param
     */
    addExerciseForShare (state, param) {
      state.examForShare.push(param)
      state.examShares.map((item) => {
        if (item.Id === param.Id) {
          item.choosed = true
        }
        return item
      })
    },

    /**
     * @author NVDuc
     * @description Set list danh sách chia sẻ
     * @param {*} state
     * @param {*} exams
     */
    setShareExercise (state, exams) {
      if (state.currentPage > 1) {
        state.dataShares = state.dataShares.concat({ exams, index: state.currentPage })
      } else {
        // Lấy giá trị lần đầu
        state.examForShare.forEach(element => {
          const index = exams.findIndex(examShare => examShare.Id === element.Id)
          if (index !== -1) {
            exams[index] = element
          }
        })
        state.dataShares = [{ exams, index: state.currentPage }]
      }
      state.dataShares.forEach(data => {
        if (data.index === state.currentPage) {
          state.examShares = data.exams
        }
      })
      // state.shareExercises = state.dataShares[0].shareExercises
    },

    /**
     * Xét giá trị cho page
     * @param {*} state
     * @param {*} currentPage
     */
    setCurrentPage (state, currentPage) {
      state.currentPage = currentPage
    },

    /**
     * @description Xóa bài tập khỏi danh sách được chia sẻ
     * @author NVDuc
     * @param {*} state
     * @param {*} param
     */
    removeExerciseForShare (state, param) {
      state.examForShare = state.examForShare.filter((x) => x !== param)
      state.examShares.map((item) => {
        if (item.Id === param.Id) {
          item.choosed = false
        }
        return item
      })
    },

    setNullExerciseForShare (state) {
      state.examForShare = []
    },

    /**
     * Chọn tất cả ExerciseShare
     * @param {*} state
     * @param {*} selectAll
     */
    setAllExercise (state, selectAll) {
      // const exerciseShares = state.shareExercises
      // Trường hợp bỏ chọn tất cả

      if (selectAll) {
        state.examShares.map((item) => {
          item.choosed = false
          return item
        })
        // Set lưu giá trị của nút chọn tất cả và bỏ chọn
        state.dataChoosePage.map(item => {
          if (item.index === state.currentPage) {
            item.selectAll = false
          }
        })
        state.examForShare = state.examForShare.filter((itemShare) => {
          return itemShare.choosed !== false
        })
        // Trường hợp duy nhất tại Page 1 khi filter
        if (state.dataShares.length <= 1) { // Số 1 nghĩa là currentpage = 1 duy nhất
          state.examForShare = []
        }
      } else {
        // TH Chọn tất cả
        state.dataChoosePage.push({ selectAll: true, index: state.currentPage })

        // Kiểm tra khi có data được chọn
        if (state.examForShare.length > 0) {
          state.examShares.map((item) => {
            const index = state.examForShare.findIndex(itemShare => itemShare.Id === item.Id)
            if (index !== -1) {
              state.examForShare.splice(index, 1)
            }
            item.choosed = true
            state.examForShare.push(item)
          })
        } else {
          // TH Chưa có data được chọn
          state.examShares.map((item) => {
            item.choosed = true
            state.examForShare.push(item)
          })
        }
      }
    },

    // Set lại giá trị khi gọi lại page
    setUpdateDataShare (state, dataShare) {
      state.examShares = dataShare.exams
    },

    // tổng số
    setTotalExercisePopup (state, totalExercise) {
      state.totalExercise = totalExercise
    },

    setFilterShare (state, currentItem) {
      state.filterStorage = JSON.parse(JSON.stringify(currentItem))
      state.currentItem = currentItem
    }

  },

  actions: {
    /**
     * @author PVThang
     * @description upsert 1 bản ghi ExamStore
     */
    upsertExam (context, params) {
      params.AppearanceType = Enumeration.AppearanceType.Single

      const examHandle = handleMappingAnswer(params, Enumeration.HandlePairingAnswerType.Convert)
      return new Promise((resolve, reject) => {
        ExamStoreAPI.addExam(examHandle).then(res => {
          if (res && examHandle.Status === Enumeration.ExerciseStatus.SaveDraft) {
            const listGiftCards = sessionStorage.get(sessionStorageKeys.TEACHER_GIFT_CARD)
            // Giảm số lượt sử dụng trên session
            const index = listGiftCards.findIndex(element => element.GiftCardType === Enumeration.GiftCardType.ComposeExamStore)
            listGiftCards[index].UsedCount++
            sessionStorage.set(sessionStorageKeys.TEACHER_GIFT_CARD, listGiftCards)
          }
          resolve(res)
        })
      })
    },

    /**
     * @author PVThang
     * @param {*} context
     * @param {*} params
     * @description Lấy danh sách exam
     */
    async getExams (context, params) {
      const quantityExam = {}
      const res = await ExamStoreAPI.getAsync('filter', {
        params: params
      })
      context.commit('setExams', res?.Data?.PageData)
      if (params.typeExam === Enumeration.TypeExam?.ExamSchool) {
        quantityExam.School = res?.Data?.Total
      } else {
        quantityExam.Teacher = res?.Data?.Total
      }
      context.commit('mergeQuantityExam', quantityExam)
    },

    /**
     * @author PVThang
     * @description lấy examStore theo id
     * @param {*} context
     * @param {*} id
     * @returns
     */
    async getExam (context, id) {
      const res = await ExamStoreAPI.getExam(id)
      const exercise = res.Data
      const exerciseHandle = handleMappingAnswer(exercise, Enumeration.HandlePairingAnswerType.Revert)

      context.commit('setExam', exerciseHandle)
      return true
    },

    /**
     * @author PVThang
     * @description xóa examStore theo id
     * @param {*} context
     * @param {*} id
     * @returns
     */
    deleteExam (context, id) {
      return new Promise((resolve, reject) => {
        ExamStoreAPI.deleteExam(id).then(res => {
          const listGiftCards = sessionStorage.get(sessionStorageKeys.TEACHER_GIFT_CARD)
          // Giảm số lượt sử dụng trên session
          const index = listGiftCards.findIndex(element => element.GiftCardType === Enumeration.GiftCardType.ComposeExamStore)
          listGiftCards[index].UsedCount--
          sessionStorage.set(sessionStorageKeys.TEACHER_GIFT_CARD, listGiftCards)
          resolve(res)
        })
      })
    },

    /**
     * @author PVThang
     * @description đếm số lượng exam store
     * @param {*} context
     */
    async countExam (context) {
      const res = await ExamStoreAPI.getAsync('count')

      if (res?.Data) {
        context.commit('mergeQuantityExam', res?.Data)
      }
    },

    /**
     * @description Hàm cập nhật lại các bài tập được chia sẻ
     * @author NVDuc
     * @param {*} context
     * @param {*} params
     * @returns
     */
    updateIsShared (context, params) {
      return new Promise((resolve, reject) => {
        ExamStoreAPI.postAsync('is-share', params)
          .then((res) => {
            context.commit('setExamShare', params.ListId)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author NVDuc
     * @description Lấy danh sách bài thi được chia sẻ theo điều kiện
     * @param {*} context
     * @param {*} params
     */
    async getExamSchoolShare (context, params) {
      const quantityExam = {}
      const res = await ExamStoreAPI.getAsync('filter/share', {
        params: params
      })
      context.commit('setExams', res?.Data?.PageData)
      quantityExam.Share = res?.Data?.Total
      context.commit('mergeQuantityExam', quantityExam)
    },

    /**
     * @description Lấy các bản ghi bài tập theo paging của giáo viên đó
     * @author BNDung
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getAllExamShared (context, currentItem) {
      return new Promise((resolve, reject) => {
        const query =
          `gradeID=${currentItem.GradeID ? currentItem.GradeID : ''}` +
          `&subjectID=${currentItem.SubjectID ? currentItem.SubjectID : ''}` +
          `&queryText=${currentItem.queryText ? currentItem.queryText : ''}` +
          `&pageIndex=${currentItem.pageIndex ? currentItem.pageIndex : ''}` +
          `&pageSize=${currentItem.pageSize ? currentItem.pageSize : ''}`
        ExamStoreAPI.getAsync('share?' + query)
          .then((res) => {
            context.commit('setFilterShare', currentItem)
            context.commit('setShareExercise', res.Data?.PageData)
            context.commit('setTotalExercisePopup', res.Data?.Total)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Sưu tầm bài kiểm tra
     * @param {*} context
     * @param {*} params
     * @returns
     */
    insertExamStore (context, params) {
      return new Promise((resolve, reject) => {
        ExamStoreAPI.postAsync('/insert?id=' + params)
          .then((res) => {
            const listGiftCards = sessionStorage.get(sessionStorageKeys.TEACHER_GIFT_CARD)
            // Giảm số lượt sử dụng trên session
            const index = listGiftCards.findIndex(element => element.GiftCardType === Enumeration.GiftCardType.ComposeExamStore)
            listGiftCards[index].UsedCount++
            sessionStorage.set(sessionStorageKeys.TEACHER_GIFT_CARD, listGiftCards)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy số lượng câu hỏi dạng tự luân
     * @param {*} context
     * @param {*} param
     * @returns
     */
    getQtyQuestionHint (context, param) {
      return new Promise((resolve, reject) => {
        ExamStoreAPI.getAsync('question-hint?id=' + param)
          .then((res) => {
            context.commit('setQtyQuestionHint', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }

  }
}
